// extracted by mini-css-extract-plugin
export default {"NoticeWrong":"NoticeWrong_NoticeWrong__z36so","WrongText":"NoticeWrong_WrongText__-aUTB","AnsText":"NoticeWrong_AnsText__lQ0sw","CorrectNote":"NoticeWrong_CorrectNote__6e0rs"};